import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["field", "submit"]
  static values = {
    requiredFields: { type: Array, default: [] },
    requiredGroups: { type: Array, default: [] }, // Used for grouping inputs of a different name for now - maybe better solution later
  }

  connect() {
    this.validate()
  }

  validate() {
    if (!this.fieldTargets) return

    this.toggleRequiredGroupCheckboxes()

    const allValid = this.fieldTargets.every(field => {
      return this.isFieldValid(field)
    })

    this.submitTarget.disabled = !allValid
    if (!allValid) {
      this.submitTarget.classList.add('bg-spring/50', 'text-spring-dark/70');
    } else {
      this.submitTarget.classList.remove('bg-spring/50', 'text-spring-dark/70');
    }
  }

  toggleRequiredGroupCheckboxes() {
    if (!this.hasRequiredGroupsValue || this.requiredGroupsValue.length === 0) return

    const groupElements = this.requiredGroupsValue.map(name =>
      document.querySelector(`[name="${name}"]:last-of-type`)
    ).filter(Boolean)

    const hasNonCheckboxValue = groupElements.some(el =>
      el.type !== 'checkbox' && el.value.trim() !== ''
    )

    groupElements.filter(el => el.type === 'checkbox').forEach(checkbox => {
      checkbox.disabled = hasNonCheckboxValue
      if (hasNonCheckboxValue) {
        checkbox.checked = false
        checkbox.classList.add('cursor-not-allowed')
      } else {
        checkbox.classList.remove('cursor-not-allowed')
      }

      const wrapper = checkbox.closest('label')
      if (wrapper) {
        wrapper.classList.toggle('cursor-not-allowed', hasNonCheckboxValue)
        wrapper.classList.toggle('opacity-70', hasNonCheckboxValue)

        const labelSpan = wrapper.querySelector('span')
        if (labelSpan) {
          labelSpan.classList.toggle('cursor-not-allowed', hasNonCheckboxValue)
          labelSpan.classList.toggle('opacity-60', hasNonCheckboxValue)
        }
      }
    })
  }

  isFieldValid(field) {
    // A disabled input is not submitted, so it cannot hold the form back. Nested records the
    // user removed are disabled rather than deleted (their _destroy flag still has to submit),
    // and their now-irrelevant values must not keep the submit button off.
    if (field.disabled) return true

    // Right now only used for dropzone on Company KYC - the step could be reworked later
    if (this.hasRequiredGroupsValue && this.requiredGroupsValue.length > 0) {
      const group = this.requiredGroupsValue.map(name => document.querySelector(`[name="${name}"]:last-of-type`))
      return Array.from(group).some(r => r.type === 'checkbox' ? r.checked : r.value.trim() !== '')
    }

    if (field.type === 'checkbox') {
      const group = document.getElementsByName(field.name);
      return Array.from(group).some(r => r.checked)
    }

    if (field.type === 'radio') {
      // check if any radio with the same name is selected
      const group = document.getElementsByName(field.name)
      return Array.from(group).some(r => r.checked)
    }

    if (field.tagName === 'SELECT') {
      return field.value !== '' && field.value !== null
    }

    if (field.tagName === 'DIV') {
      const inputs = [...field.querySelectorAll('input')].filter(input => !input.disabled)

      if (inputs.length === 0) return false

      return inputs.every(input => {
        return this.isFieldValid(input)
      })
    }

    // Text inputs, textareas, hidden inputs (like Dropzone)
    return field.value.trim() !== ''
  }
}
